import React, {useCallback} from 'react';
import {Input, Radio} from "presentation/common";

export const IsOwnerInput = props => {
  const {
    required,
    name,
    error,
    value,
    onChange,
    onBlur,
    ...other
  } = props;

  const onChangeIsOwner = useCallback((e) => {
    onBlur?.({
      target: {name},
    });

    onChange?.({
      target: {name, value: e.target.value},
    });
  }, []);

  return (
    <Input {...other} required={required} error={error}>
      <div className='flex gap-2 mt-2 items-center'>
        <Radio name="isOwner" value="1" label="Sí" radioClassName='mt-1' checked={value === "1"} onChange={onChangeIsOwner}/>
        <Radio name="isOwner" value="0" label="No" radioClassName='mt-1' checked={value === "0"} onChange={onChangeIsOwner}/>
      </div>
    </Input>
  );
};
